var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-list"},[_c('FilterGrid',{attrs:{"only":['accordion'],"clear-button":false,"on-accordion-select":function (value) { return this$1.onSelectFilter(value); },"use-sub-selection":_vm.useSubSelection,"selected-levels":_vm.selectedLevels,"selected-question":_vm.selectedQuestion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }